import {
  FottServiceRequestStatus,
  FottServiceType,
  type FottServiceRequestStatus as FottServiceRequestStatusValue,
  type FottServiceType as FottServiceTypeValue,
} from "@services/terminal-services/types";
import { convertUtcToUae, formatDateToDDMMYYYY } from "@utils/date-time";

const SERVICE_TYPE_ALIASES: Record<string, FottServiceTypeValue> = {
  [FottServiceType.GANTRY_CRANE_SERVICE]: FottServiceType.GANTRY_CRANE_SERVICE,
  [FottServiceType.NITROGEN_SUPPLY_SERVICE]: FottServiceType.NITROGEN_SUPPLY_SERVICE,
  [FottServiceType.PIGGING_SERVICE]: FottServiceType.PIGGING_SERVICE,
  [FottServiceType.BYPASS_SERVICE]: FottServiceType.BYPASS_SERVICE,
  GANTRY_CRANE: FottServiceType.GANTRY_CRANE_SERVICE,
  NITROGEN_SUPPLY: FottServiceType.NITROGEN_SUPPLY_SERVICE,
  PIGGING: FottServiceType.PIGGING_SERVICE,
  BYPASS: FottServiceType.BYPASS_SERVICE,
};

export const normalizeFottServiceType = (serviceType?: string | null): FottServiceTypeValue => {
  if (!serviceType) return FottServiceType.GANTRY_CRANE_SERVICE;

  const normalized = serviceType.trim().replace(/-/g, "_").toUpperCase();

  return SERVICE_TYPE_ALIASES[normalized] ?? FottServiceType.GANTRY_CRANE_SERVICE;
};

export const getTerminalServiceStatusBadgeType = (
  status?: FottServiceRequestStatusValue | string | null,
): "success" | "warning" | "error" | "neutral" => {
  switch (status) {
    case FottServiceRequestStatus.APPROVED:
    case FottServiceRequestStatus.CLOSED:
      return "success";
    case FottServiceRequestStatus.REJECTED:
    case FottServiceRequestStatus.CANCELLED:
      return "error";
    case FottServiceRequestStatus.PENDING_APPROVAL:
    default:
      return "warning";
  }
};

export const formatTerminalServiceDateTime = (value?: string | null) => {
  if (!value) return "-";

  try {
    return formatDateToDDMMYYYY(convertUtcToUae(value), true);
  } catch {
    return "-";
  }
};
